export default __webpack_public_path__ + "static/icon-26-4-f8480fad8a126b68ccc29a049cf28425.png";